module.exports = __webpack_public_path__ + "img/aomen1.36059ca9.jpg";